import styled, { css } from 'styled-components';

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 535px;
    padding: 24px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding 20px;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
    max-width: 383px;
    z-index: 2;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
      max-width: 260px;
    }
  `}
`;

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 8px 0px 0px 0px;
    max-width: 330px;
    z-index: 2;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxxs};
      max-width: 270px;
    }
 `}
`;

export const SvgWrapper = styled.div`
  ${({ theme }) => css`
    bottom 18px;
    position: absolute;
    right: 0px;
    z-index: 1;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      right: -35px;
    }
  `}
`;


export const ButtonWrapper = styled.div`
  max-width: 280px;
`;
